import { ChangeColor } from './ChangeColor';

export class ChangeTertiaryColor extends ChangeColor {
  type: string = 'ChangeTertiaryColor';
}
